import React, { Component, Fragment } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import { connect } from 'react-redux';
import './TaskCard.module.scss';
import { Droppable } from 'react-beautiful-dnd';
import customIsoString from 'utilities/custom-iso-string';

/**
 * Import components
 */
import TaskCardItem from 'components/UI/TaskCard/TaskCardItem/TaskCardItem';

/**
 * Import Selectors
 */
import getTaskByDate from 'selectors/task/date';
import getHolidayByDate from 'selectors/holiday/holi-day';

/*
*   Import Fontawesome
*/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const mapStateToProps = (state, props) => {
    return {
        agendaVisibility: state.agenda,
        tasks: getTaskByDate(state, props),
        subjects: state.user_subject.entities,
        holiday: getHolidayByDate(state, props),
        homework: state.homework.entities,
        user: state.authentication.user
    };
};

class TaskCard extends Component {
    constructor(props) {
        super(props);

        this.goToTimer              = this.goToTimer.bind(this);
        this.showInputMisc          = this.showInputMisc.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        //block render when parent is updating task order
        if (this.props.blockUpdates == true && nextProps.blockUpdates != false) {
            return false;
        }
        return true;
    }

    goToTimer() {

        let date = this.props.date;

        let month = parseInt(date.getMonth() + 1);
        if (month < 10) {
            month = `0${month}`;
        }

        let day = parseInt(date.getDate());
        if (day < 10) {
            day = `0${day}`;
        }

        let dateString = `${date.getFullYear()}-${month}-${day}`;

        history.push(`/timer/${dateString}`);
    }

    checkDate(date) {
        const today = new Date();
        return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
    }

    showInputMisc() {
        this.props.showInputMisc(this.props.date);
    }

    render() {
        const { dark, index, disabled, user, holiday, deadline } = this.props;
        const days = [ 'Zondag','Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag' ];
        const months = [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december' ];

        //Determines day based on current date

        let currentDate = this.props.date;

        let title = this.checkDate(currentDate) ? 'Vandaag' : '';

        let dayOfWeek = currentDate.getDay();

        let date = currentDate.getDate() + ' ' + months[currentDate.getMonth()];

        const amountOfCardItems = 9;
        const emptyItems = [];

        let taskLength = this.props.tasks.length;

        let totalPlannedMinutes = 0;

        if (this.props.tasks.length > 0) {
            let taskTime = 0;
            this.props.tasks.map(task => {
                taskTime = parseInt(task.time);
                return totalPlannedMinutes += taskTime;
            });
        }

        let isDropDisabled = false;
        if (disabled) {
            isDropDisabled = true;
        }

        //Calculate if cards are in the past, needed for empty taskcarditems
        var today = new Date();

        let isPastCard = false;
        if (this.checkDate(currentDate)) {
            isPastCard = false;
        } else if (currentDate < today) {
            isPastCard = true;
        } else {
            isPastCard = false;
        }

        for (var i = 0; i < (amountOfCardItems - taskLength); i++) {
            emptyItems.push(<TaskCardItem key={i} weekend={dayOfWeek == 0 || dayOfWeek == 6} dark empty isPastCard={isPastCard} showInputMisc={this.showInputMisc}/>);
        }

        //Split deadline and taskcard date in order to check
        let deadlineDate = deadline && deadline.toDateString();
        let currentTaskCardDate =this.props.date && this.props.date.toDateString();   

        return (
            <div styleName={`card-background ${this.props.large ? 'large' : ''} ${disabled ? 'disabled' : ''} ${isPastCard ? 'past-card' : '' }`}>
                {    deadlineDate == currentTaskCardDate &&
                <div styleName='deadlineDate'>
                    <p>Deadline / Dag van huiswerk</p>  
                </div>

                }  
                {this.props.past ? <div styleName='inside-wrapper'/> : null }
                {this.props.large ? this.props.children :
                    <Fragment>
                        <div styleName={`card-details ${taskLength > 0 ? 'holiday' : ''}`}>
                            <div styleName='date-information'>
                                <h2 styleName={`title ${title == 'Vandaag' ? 'today' : ''}`} >{ title && title || days[currentDate.getDay()]}</h2>
                                <p styleName={`date ${(holiday && holiday.special == 0) ? 'isHoliday' : ''}`}>{holiday && holiday.special == 1 && <div styleName='single-holiday-indicator'></div>}{date}</p>
                            </div>
                            {
                                taskLength > 0 &&
                                <Fragment>
                                    <div styleName='homework-detail-wrapper'>
                                        <FontAwesomeIcon icon={[ 'fas', 'play' ]} styleName='icon' onClick={this.goToTimer}/>
                                        <div styleName='homework-detail'>
                                            <h2>{this.props.tasks.filter((task) => task.status == 'finished').length}/{taskLength}</h2>
                                            {
                                                user && user.use_timer && this.props.agendaVisibility.time ?
                                                    <p style={holiday ? { marginBottom: '0' } : {}}>{totalPlannedMinutes} min</p>
                                                    : null
                                            }

                                        </div>
                                    </div>
                                </Fragment>
                            }
                        </div>
                        {
                            holiday && holiday.special == 0 && (
                                <div styleName={`holiday-wrapper ${title == 'Vandaag' ? 'today' : ''}`}>
                                    <div styleName='holiday-line'></div>
                                </div>
                            )
                        }
                        <Droppable isDropDisabled={isDropDisabled || (this.props.tasks.length >= 9 && (this.props.currentTaskDate != null && currentTaskCardDate != this.props.currentTaskDate.toDateString()) || (this.props.tasks.length >= 9 && this.props.currentTaskDate == null) )} droppableId={ customIsoString(currentDate).split('T')[0]}>
                            {(provided ) => (

                                <div
                                    styleName='tasks-droppable'
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    tasks={this.props.tasks}
                                    
                                >
                                    {
                                        this.props.tasks.sort((a,b) => a.order - b.order).map((task, index ) => {
                                            return <TaskCardItem
                                                dark={dark}
                                                task={task}
                                                weekend={dayOfWeek == 0 || dayOfWeek == 6}
                                                key={index}
                                                index={index}
                                                isPastCard={isPastCard}
                                                homework={this.props.homework}>
                                            </TaskCardItem>;
                                        })
                                    }
                                    {
                                        provided.placeholder
                                    }
                                    {
                                        emptyItems
                                    }

                                </div>


                            )
                            }


                        </Droppable>
                    </Fragment>
                }

            </div>

        );
    }
}

export default connect(mapStateToProps, null)(TaskCard);
